import { createClient } from '@supabase/supabase-js';

// CRA uses REACT_APP_* prefix for environment variables
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    console.warn('[Supabase] REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY is not set. Auth features will not work.');
}

export const supabase = createClient(
    SUPABASE_URL || 'https://placeholder.supabase.co',
    SUPABASE_ANON_KEY || 'placeholder-anon-key',
    {
        auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: true,
            // Use 'implicit' flow. This guarantees that magic links (containing the access
            // token in the URL hash fragment) can successfully establish a session even when
            // opened in a different browser, default app viewer, or private tab without
            // requiring a locally stored PKCE code_verifier.
            flowType: 'implicit',
        }
    }
);

export default supabase;
